import {Box} from '@mui/material'
import DoNotDisturbOnOutlinedIcon from '@mui/icons-material/DoNotDisturbOnOutlined'
import {styled} from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import PropTypes from 'prop-types'

const PREFIX = 'AllProspectsLoadingError'
const classes = {
  root: `${PREFIX}-root`,
  icon: `${PREFIX}-icon`,
  loadDataBoxAction: `${PREFIX}-loadDataBoxAction`
}

const StyledBox = styled(Box, {shouldForwardProp: (prop) => prop !== 'height'})(({theme, height}) => ({
  marginTop: height / 2,
  [`&.${classes.root}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    position: 'relative',
    justifyContent: 'center'
  },

  [`& .${classes.icon}`]: {
    height: '0.4em',
    width: '0.4em'
  },

  [`& .${classes.loadDataBoxAction}`]: {
    fontWeight: theme.typography.heading.fontWeight.bold,
    fontSize: theme.typography.heading.fontSize.s,
    color: theme.palette.common.grey
  }
}))

const StyledDoNotDisturbOnOutlinedIcon = styled(DoNotDisturbOnOutlinedIcon)(({theme}) => ({
  fontSize: '30px',
  color: theme.palette.common.grey
}))

const NoData = ({height, message = 'No data available for the given selection. Please check the filters.'}) => {
  return (
    <StyledBox height={height} className={classes.root}>
      <StyledDoNotDisturbOnOutlinedIcon
        style={{
          width: classes.icon.width,
          height: classes.icon.height
        }}
        classes={{colorPrimary: classes.icon}}
      />
      <Typography variant="h6" className={classes.loadDataBoxAction}>
        {message}
      </Typography>
    </StyledBox>
  )
}

NoData.propTypes = {
  height: PropTypes.number,
  message: PropTypes.string
}

export default NoData
